module.exports = __webpack_public_path__ + "static/img/dialog3.fd1dff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/dialog3.png
// module id = 6uBu
// module chunks = 0